import { useRequest } from 'ahooks'
import { MILLISECONDS_IN_A_DAY } from '@/constants'
import { useBtc } from '@/context/BtcContext'

const useBtcSign = ({
  message,
  cacheKey,
  manual = false,
}: {
  message: string
  cacheKey?: string
  manual?: boolean
}) => {
  const { address, isConnected, signMessage, connectorName } = useBtc()

  return useRequest(
    async () => {
      if (!isConnected) {
        return Promise.reject(Error('Not connected'))
      }

      if (
        sessionStorage.getItem(cacheKey) &&
        JSON.parse(sessionStorage.getItem(cacheKey)).data.address === address &&
        JSON.parse(sessionStorage.getItem(cacheKey)).data.wallet === connectorName
      ) {
        const obj = JSON.parse(sessionStorage.getItem(cacheKey))

        return obj.data
      }

      const signature = await signMessage(message)

      return { address, signature, message, wallet: connectorName }
    },
    {
      cacheKey,
      manual,
      ready: isConnected,
      refreshDeps: [address, isConnected, connectorName],
      setCache: (data) => sessionStorage.setItem(cacheKey, JSON.stringify(data)),
      getCache: () => {
        const storage = JSON.parse(sessionStorage.getItem(cacheKey) || '{}')

        if (!isConnected || Date.now() - storage?.time >= 6 * MILLISECONDS_IN_A_DAY) return undefined

        return storage
      },
      onError: (error) => {
        console.log('btc sign error: ', error)
      },
    },
  )
}

export default useBtcSign
